var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('themed-button',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.downloadData()}}},[_c('themed-icon',[_vm._v("\n        mdi-download\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }